var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.67578,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.3424H14.5V9.29483C14.5 7.84911 13.38 6.67578 12 6.67578C10.62 6.67578 9.5 7.84911 9.5 9.29483V10.3424H9C8.4475 10.3424 8 10.8113 8 11.3901V16.6282C8 17.207 8.4475 17.6758 9 17.6758H15C15.5525 17.6758 16 17.207 16 16.6282V11.3901C16 10.8113 15.5525 10.3424 15 10.3424ZM12 15.0567C11.4475 15.0567 11 14.5879 11 14.0091C11 13.4303 11.4475 12.9615 12 12.9615C12.5525 12.9615 13 13.4303 13 14.0091C13 14.5879 12.5525 15.0567 12 15.0567ZM13.55 10.3424H10.45V9.29483C10.45 8.39911 11.145 7.67102 12 7.67102C12.855 7.67102 13.55 8.39911 13.55 9.29483V10.3424Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLock);
export default __webpack_public_path__ + "static/media/TextLock.9700a1bf.svg";
export { ForwardRef as ReactComponent };